type LocalizedNames = { name_uz: string; name_ru: string; name_en: string };

export const categoryLabel = (item: LocalizedNames, lang: string | undefined): string => {
  const code = (lang ?? 'uz').slice(0, 2);
  if (code === 'ru') return item.name_ru || item.name_uz;
  if (code === 'en') return item.name_en || item.name_uz;
  return item.name_uz;
};
